<template>
  <div class="default-wrapper">
    <!-- <div class="nodata bgimg"></div> -->
    <p class="tips">{{msg}}</p>
  </div>
</template>

<script type="text/javascript">
  export default {
    props: {
      msg: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .default-wrapper{
    text-align: center;
    padding: 18px 0;
  }
  .tips{
    // margin-top: 18px;
    font-size: 14px;
    color: #999;
  }
  .nodata{
    // background: url(~common/images/state-nothing@2x.png);
  }
  .bgimg{
    display: inline-block;
    width: 134px;
    height: 134px;
    background-size: contain;
    background-repeat: no-repeat;
  }
</style>